import { motion } from 'framer-motion';
import styled from 'styled-components';
import { BREAKPOINTS } from 'styles/media';

export const CompanyResourceFullscreen = styled.div<{ $overlay?: boolean }>`
  position: fixed;
  inset: 0;
  z-index: ${({ $overlay }) => ($overlay ? 2147483646 : 1)};
  width: 100vw;
  height: 100svh;
  display: flex;
  flex-direction: column;
  overflow: auto;
  background: #000000;
`;

export const CompanyResourceObject = styled(motion.iframe)<{
  $whiteBackgroundFallback?: boolean;
}>`
  display: block;
  width: 100%;
  height: 100%;
  min-height: 0;
  flex: 1;
  border: 0;
  background: ${({ $whiteBackgroundFallback }) =>
    $whiteBackgroundFallback ? '#ffffff' : '#000000'};
`;

export const CompanyResourceImage = styled.img`
  display: block;
  width: 100%;
  min-height: 0;
  flex: 1;
  object-fit: contain;
  background: #000000;
`;

export const CompanyResourceClose = styled.button`
  position: fixed;
  top: 16px;
  right: 16px;
  z-index: 2;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 48px;
  height: 48px;
  padding: 0;
  border: 0;
  border-radius: 50%;
  background: #ffffff;
  box-shadow: 0px 4px 30px -10px rgba(0, 0, 0, 0.5);
  cursor: pointer;

  &:focus-visible {
    outline: 3px solid var(--color-primary);
    outline-offset: 2px;
  }
`;

export const CompanyResourceFooterHider = styled.div`
  height: 24px;
  position: absolute;
  bottom: 0;
  width: 100%;
  background-color: #191f37;

  ${BREAKPOINTS.tablet} {
    margin-top: 0px !important;
    height: calc(100vh - 56px) !important;
  }
`;

export const CompanyResourceErrorWrapper = styled.div`
  background-image: url('/backgrounds/stars-home.svg');
  background-color: var(--color-primary);
  height: 100vh;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;

  padding: 0px 58px;

  & > :not(:last-child) {
    margin-bottom: 27px;
  }

  background-repeat: no-repeat;
  background-size: cover;

  &:before {
    position: absolute;
    content: '';
    height: 100%;
    width: 100%;
    backdrop-filter: blur(12px);
    box-shadow: inset 0px 0px 207px -8px rgba(0, 0, 0, 0.75);
  }
`;

export const CompanyResourceErrorTitle = styled.h1`
  font-family: 'EB Garamond', sans-serif !important;
  font-style: normal;
  font-weight: 500;
  font-size: 44px;
  line-height: 42px;
  text-align: center;
  text-transform: capitalize;
  color: #ffffff;

  z-index: 1;
`;

export const CompanyResourceErrorText = styled.p`
  font-weight: 300;
  font-size: 16px;
  line-height: 180%;
  text-align: center;
  color: #ffffff;

  z-index: 1;
`;
